class PageHeaderSearch {
  constructor() {
    this.closeButtons = document.querySelectorAll('.wt-header__search__close');
    this.cancelButton = document.querySelector('.search-results-redesign__cancel-btn');
    this.searchDrawer = document.querySelector('search-drawer');
    this.searchInputs = document.querySelectorAll('.wt-header__search__field');
    this.searchForm = document.querySelectorAll('.wt-header__search__form');
    this.clearTexts = document.querySelectorAll('.wt-header__search__clear-text');
    this.middleColumn = document.querySelector('.search-results-redesign__products');
    this.leftColumn = document.querySelector('.search-results-redesign__suggestions');
    this.searchContainer = document.querySelector('.search-results-redesign__container');
    
    this.originalMiddleColumnContent = '';
    this.originalLeftColumnContent = '';
    this.currentSearchTerm = '';
    this.currentSearchAbortController = null;
    this.searchTimeout = null;
    
    this.productPriority = this.searchDrawer ? 
      this.searchDrawer.getAttribute('data-product-priority') || 'sale' : 'sale';
    
    // Get the current locale from the URL path
    this.locale = this.getLocaleFromPath();
    
    // HTML escape function to prevent XSS
    this.escapeHtml = (text) => {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    };
    
    this.sanitizeUrl = (url) => {
      if (!url) return '';
      const trimmedUrl = String(url).trim();
      if (trimmedUrl.startsWith('http:') || trimmedUrl.startsWith('https:') || trimmedUrl.startsWith('/')) {
        return trimmedUrl;
      }
      return ''; 
    };
    
    console.log('Search drawer element:', this.searchDrawer);
    
    this.t = (key) => {
      if (!this.searchDrawer) return key.split('.').pop().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      
      const translationMap = {
        'search.no_results_found': 'data-translation-no-results-found',
        'search.see_bestsellers': 'data-translation-see-bestsellers',
        'search.searching': 'data-translation-searching',
        'search.try_searching_else': 'data-translation-try-searching-else',
        'search.titles.products': 'data-translation-products',
        'search.titles.pages': 'data-translation-pages',
        'search.titles.products_and_pages': 'data-translation-products-and-pages',
        'search.view_all': 'data-translation-view-all'
      };
      
      const dataAttribute = translationMap[key];
      if (dataAttribute) {
        const translation = this.searchDrawer.getAttribute(dataAttribute);
        if (translation) {
          return translation;
        }
      }
      
      // Fallback to hardcoded English translations
      const fallbackTranslations = {
        'search.no_results_found': 'No Results Found',
        'search.see_bestsellers': 'See bestsellers',
        'search.searching': 'Searching...',
        'search.try_searching_else': 'Try searching for something else or browse our collections.',
        'search.titles.products': 'Products',
        'search.titles.pages': 'Pages',
        'search.titles.products_and_pages': 'Products & Pages',
        'search.view_all': 'View all'
      };
      
      return fallbackTranslations[key] || key.split('.').pop().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    };
    
    this.storeDataCache = {
      collections: [],
      productTypes: [],
      tags: [],
      lastUpdated: null,
      cacheExpiry: 5 * 60 * 1000
    };
    this.collectionValidationCache = new Map();
    this.ENABLE_COLLECTION_VALIDATION = false;
    this.ENABLE_COUNTRY_FILTERING = true; // Re-enable country filtering
    this.ENABLE_SUGGESTION_VALIDATION = true;
    
    // Get current country from the page
    this.currentCountry = this.getCurrentCountry();

    this.searchSynonyms = this.parseSearchSynonyms();

    this.init();
  }

  normalizeSearchTerm(searchTerm) {
    if (!searchTerm) return '';
    return String(searchTerm)
      .normalize('NFKC')
      .replace(/[\u2018\u2019\u201A\u201B\u2032\u2035\u02BC']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  getLocaleFromPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      const root = window.Shopify.routes.root;
      if (root && root !== '/' && root !== '/en' && root !== '/en/') {
        return root.replace(/\/$/, ''); // Remove trailing slash
      }
    }
    
    const pathMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//i);
    if (pathMatch) {
      return `/${pathMatch[1]}`;
    }
    
    // Try to get from Shopify locale if available
    if (window.Shopify && window.Shopify.locale) {
      const locale = window.Shopify.locale.toLowerCase();
      if (locale !== 'en' && locale.indexOf('-') > -1) {
        return `/${locale}`;
      }
    }
    
    const htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang && htmlLang !== 'en' && htmlLang.indexOf('-') > -1) {
      return `/${htmlLang.toLowerCase()}`;
    }
    
    return '';
  }

  init() {
    document.body.classList.remove('search-overlay-on');
            this.closeButtons.forEach((closeButton, index) => {
      if (closeButton) {
        closeButton.style.display = 'none';
      }
    });
    
    if (this.middleColumn) {
      this.originalMiddleColumnContent = this.middleColumn.innerHTML;
    }
    
    if (this.leftColumn) {
      this.originalLeftColumnContent = this.leftColumn.innerHTML;
    }
    
    this.setupEventListeners();
    
    // Initialize FAQ state
    this.checkSearchState();
  }

  // ===========================================
  // COUNTRY DETECTION AND FILTERING
  // ===========================================
  getCurrentCountry() {
    // Try to get country from Shopify's localization data
    if (window.Shopify && window.Shopify.locale) {
      const locale = window.Shopify.locale;
      if (locale.includes('-')) {
        return locale.split('-')[1].toUpperCase();
      }
    }
    
    const htmlElement = document.documentElement;
    const lang = htmlElement.getAttribute('lang');
    
    if (lang && lang.includes('-')) {
      return lang.split('-')[1].toUpperCase();
    }
    
    // Try to get from the country localization form input
    const countryInput = document.querySelector('input[name="country_code"]');
    if (countryInput && countryInput.value) {
      return countryInput.value.toUpperCase();
    }
    
    // Fallback: try to detect from URL or other indicators
    const hostname = window.location.hostname;
    if (hostname.includes('.co.uk') || hostname.includes('uk.')) {
      return 'GB';
    } else if (hostname.includes('.com.au') || hostname.includes('au.')) {
      return 'AU';
    } else if (hostname.includes('.ca') || hostname.includes('ca.')) {
      return 'CA';
    } else if (hostname.includes('.de') || hostname.includes('de.')) {
      return 'DE';
    } else if (hostname.includes('.fr') || hostname.includes('fr.')) {
      return 'FR';
    }
    
    // Default fallback
    return 'US';
  }

  isCollectionForCurrentCountry(collectionTitle) {
    const title = collectionTitle.toLowerCase();
    const currentCountry = this.currentCountry.toLowerCase();
    
    
    if (!currentCountry || currentCountry === 'unknown' || currentCountry === '') {
      return true;
    }
    
    // Country name mappings
    const countryMappings = {
      'us': ['us', 'usa', 'united states', 'america', 'american'],
      'gb': ['gb', 'uk', 'united kingdom', 'britain', 'british', 'england', 'scotland', 'wales'],
      'au': ['au', 'australia', 'australian'],
      'ca': ['ca', 'canada', 'canadian'],
      'de': ['de', 'germany', 'german', 'deutschland'],
      'fr': ['fr', 'france', 'french', 'français'],
      'it': ['it', 'italy', 'italian', 'italia'],
      'es': ['es', 'spain', 'spanish', 'españa'],
      'nl': ['nl', 'netherlands', 'dutch', 'holland'],
      'be': ['be', 'belgium', 'belgian'],
      'ch': ['ch', 'switzerland', 'swiss']
    };
    
    // Get current country terms
    const currentCountryTerms = countryMappings[currentCountry] || [currentCountry];
    
    // Check if collection title contains any country-specific terms for OTHER countries.
    // Word boundaries stop two-letter codes (e.g. "ca") matching inside unrelated words
    // like "Cardholders". Underscores are word characters, so "_ca" needs its own pattern.
    for (const [countryCode, terms] of Object.entries(countryMappings)) {
      if (countryCode !== currentCountry) {
        for (const term of terms) {
          const patterns = [
            `\\b${term}\\b`,
            `_${term}\\b`,
          ];

          for (const pattern of patterns) {
            const regex = new RegExp(pattern, 'i');
            if (regex.test(title)) {
              return false;
            }
          }
        }
      }
    }
    
    return true;
  }

  // ===========================================
  // SEARCH SYNONYMS (curated metaobject)
  // ===========================================
  parseSearchSynonyms() {
    if (!this.searchDrawer) return [];
    const raw = this.searchDrawer.getAttribute('data-search-synonyms');
    if (!raw) return [];
    try {
      const entries = JSON.parse(raw);
      if (!Array.isArray(entries)) return [];
      // Normalise terms to lowercase array per entry
      return entries
        .filter(entry => entry && typeof entry === 'object')
        .map(entry => {
        const termsRaw = entry.terms;
        let terms = [];
        if (Array.isArray(termsRaw)) {
          terms = termsRaw;
        } else if (typeof termsRaw === 'string') {
          terms = termsRaw.split(',');
        }
        terms = terms.map(term => String(term).trim().toLowerCase()).filter(Boolean);
        return {
          terms,
          handle: entry.handle || '',
          title: entry.title || '',
          url: entry.url || (entry.handle ? `/collections/${entry.handle}` : ''),
          label: entry.label || entry.title || '',
          priority: Number(entry.priority) || 0
        };
      }).filter(entry => entry.terms.length > 0 && entry.handle);
    } catch (error) {
      console.warn('Failed to parse search synonyms:', error);
      return [];
    }
  }

  findSynonymMatches(searchTerm) {
    if (!this.searchSynonyms || !this.searchSynonyms.length) return [];
    const term = searchTerm.trim().toLowerCase();
    if (!term) return [];
    const termWords = term.split(/\s+/).filter(Boolean);

    const matches = [];
    const seen = new Set();

    for (const entry of this.searchSynonyms) {
      const hit = entry.terms.some(synonymTerm => {
        if (term === synonymTerm) return true;
        if (synonymTerm.includes(' ')) {
          return term.includes(synonymTerm);
        }
        // Single-word synonym: match if any user word starts with or equals it.
        // Reverse-prefix (word completes to synonym) requires 3+ chars to avoid flood-matching on a single letter.
        return termWords.some(word =>
          word === synonymTerm
          || word.startsWith(synonymTerm)
          || (word.length >= 3 && synonymTerm.startsWith(word))
        );
      });
      if (hit && !seen.has(entry.handle)) {
        seen.add(entry.handle);
        matches.push(entry);
      }
    }

    matches.sort((a, b) => b.priority - a.priority);
    return matches;
  }

  // ===========================================
  // FAQ STATE MANAGEMENT
  // ===========================================
  toggleSearchState(isActive) {
    if (this.searchContainer) {
      if (isActive) {
        this.searchContainer.classList.add('search-active');
      } else {
        this.searchContainer.classList.remove('search-active');
      }
    }
  }
  
  checkSearchState() {
    let hasValue = false;
    this.searchInputs.forEach(input => {
      if (input.value.trim().length > 0) {
        hasValue = true;
      }
    });
    this.toggleSearchState(hasValue);
  }

  // ===========================================
  // DRAWER OPEN/CLOSE FUNCTIONS
  // ===========================================
  openSearchDrawer() {
    if (this.searchDrawer) {
      this.searchDrawer.classList.add('wt-drawer-search--active');
      document.body.classList.add('search-overlay-on');
      this.closeButtons.forEach(closeButton => {
        closeButton.style.display = 'flex';
      });
      const drawerSearchInput = this.searchDrawer.querySelector('.wt-header__search__field');
      if (drawerSearchInput) {
        drawerSearchInput.focus();
      }
    }
  }
  
  closeSearchDrawer() {
    if (this.searchDrawer) {
      this.searchDrawer.classList.remove('wt-drawer-search--active');
      document.body.classList.remove('search-overlay-on');
      this.closeButtons.forEach(closeButton => {
        closeButton.style.display = 'none';
      });
      if (this.middleColumn && this.originalMiddleColumnContent) {
        this.middleColumn.innerHTML = this.originalMiddleColumnContent;
      }
    }
  }
    
  // ===========================================
  // EVENT LISTENERS SETUP
  // ===========================================
  setupEventListeners() {
    if (this.searchForm && this.searchForm.length > 0 && this.searchDrawer) {
      this.searchForm.forEach((form) => {
        form.addEventListener('click', (e) => {
          e.preventDefault();
          this.openSearchDrawer();
        });
        
        form.addEventListener('submit', (e) => {
          const searchInput = form.querySelector('.wt-header__search__field');
          if (searchInput) {
            const searchTerm = this.normalizeSearchTerm(searchInput.value);
            if (searchTerm.length > 0) {
              e.preventDefault();
              window.location.href = `${this.locale}/search?q=${encodeURIComponent(searchTerm)}`;
            } else if (searchInput.value.trim().length > 0) {
              e.preventDefault();
            }
          }
        });
      });
    }
    
    const mobileSearchIcon = document.querySelector('.mobile-search-icon');
    if (mobileSearchIcon && this.searchDrawer) {
      mobileSearchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSearchDrawer();
      });
    }
    
    const searchTriggers = document.querySelectorAll('.wt-header__search-trigger');
    searchTriggers.forEach((trigger) => {
      if (trigger && this.searchDrawer && !trigger.closest('.wt-drawer-search')) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openSearchDrawer();
        });
      }
    });
    
    this.closeButtons.forEach((closeButton, index) => {
      if (closeButton && this.searchDrawer) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeSearchDrawer();
        });
      }
    });
    
    if (this.cancelButton && this.searchDrawer) {
      this.cancelButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeSearchDrawer();
      });
    }
    
    if (this.searchInputs && this.searchInputs.length > 0 && this.searchDrawer) {
      this.searchInputs.forEach((searchInput) => {
        searchInput.addEventListener('focus', (e) => {
          this.openSearchDrawer();
          this.checkSearchState();
        });
        
        searchInput.addEventListener('click', (e) => {
          this.openSearchDrawer();
          this.checkSearchState();
        });
        
        searchInput.addEventListener('blur', (e) => {
          this.checkSearchState();
        });
        
        searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            const searchTerm = this.normalizeSearchTerm(e.target.value);
            if (searchTerm.length > 0) {
              e.preventDefault();
              window.location.href = `${this.locale}/search?q=${encodeURIComponent(searchTerm)}`;
            } else if (e.target.value.trim().length > 0) {
              e.preventDefault();
            }
          }
        });
        
        searchInput.addEventListener('input', (e) => {
          const form = e.target.closest('.wt-header__search__form');
          const formClearText = form ? form.querySelector('.wt-header__search__clear-text') : null;
          
          if (formClearText) {
            if (e.target.value.length > 0) {
              formClearText.classList.add('show');
            } else {
              formClearText.classList.remove('show');
            }
          }
          
          // Update FAQ state
          this.checkSearchState();
          
          const searchTerm = this.normalizeSearchTerm(e.target.value);
          
          // Clear any existing timeout
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
          }
          
          if (searchTerm.length > 0) {
            // Debounce the search by 300ms
            this.searchTimeout = setTimeout(() => {
              this.performPredictiveSearch(searchTerm);
            }, 300);
          } else {
            // Clear search immediately when input is empty
            this.clearSearch();
          }
        });
      });
    }
    
    if (this.clearTexts && this.clearTexts.length > 0) {
      this.clearTexts.forEach((clearText) => {
        clearText.addEventListener('click', (e) => {
          e.preventDefault();
  
          this.searchInputs.forEach((searchInput) => {
            searchInput.value = '';
          });
          
          this.clearTexts.forEach((ct) => {
            ct.classList.remove('show');
          });
          
          // Update FAQ state
          this.checkSearchState();
          
          // Use the new clearSearch method
          this.clearSearch();
        });
      });
    }
  }
    
  // ===========================================
  // AJAX STATE FETCHING FUNCTIONS
  // ===========================================
  fetchLoadingState(middleColumn) {
    const loadingUrl = `${window.routes.search_url}?section_id=search-results-ajax&state=loading`;
    
    fetch(loadingUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then(text => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const loadingState = doc.querySelector('#ajax-search-results');
        
        if (loadingState) {
          middleColumn.innerHTML = loadingState.innerHTML;
        } else {
          middleColumn.innerHTML = `<h3 class="search-results-redesign__title">${this.t('search.searching')}</h3>`;
        }
      })
      .catch(error => {
        middleColumn.innerHTML = `<h3 class="search-results-redesign__title">${this.t('search.searching')}</h3>`;
      });
  }

  fetchNoResultsState(middleColumn) {
    if (this.middleColumn && this.originalMiddleColumnContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.originalMiddleColumnContent;
      
      const originalTitle = tempDiv.querySelector('.search-results-redesign__title');
      if (originalTitle) {
        originalTitle.style.display = 'none';
      }
      
      const subtitleText = this.middleColumn.dataset.noResultsSubtitle || this.t('search.see_bestsellers');
      const subtitleUrl = this.middleColumn.dataset.noResultsSubtitleUrl || '';
      
      const subtitleElement = subtitleUrl 
        ? `<a href="${subtitleUrl}" class="search-results-redesign__subtitle search-results-redesign__subtitle--link">${subtitleText}</a>`
        : `<p class="search-results-redesign__subtitle">${subtitleText}</p>`;
      
      const noResultsHTML = `
        <div class="search-results-redesign__title-header">
          <h3 class="search-results-redesign__title">${this.t('search.no_results_found')}</h3>
          ${subtitleElement}
        </div>
        ${tempDiv.innerHTML}
      `;
      this.middleColumn.innerHTML = noResultsHTML;
    }
  }
  


  // ===========================================
  // SUGGESTION HANDLERS
  // ===========================================
  addSuggestionClickHandlers(suggestionsListElement) {
    const suggestionLinks = suggestionsListElement.querySelectorAll('.search-results-redesign__suggestion-link');
    
    suggestionLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        const suggestionText = link.getAttribute('data-suggestion-text');
        const suggestionUrl = link.getAttribute('href');
        
        if (suggestionText) {
          // For collection URLs, navigate directly to the collection page
          if (suggestionUrl && suggestionUrl.includes('/collections/')) {
            window.location.href = suggestionUrl;
            return;
          }
          
          // For all other suggestions, navigate to the main search page with the search term
          window.location.href = `${this.locale}/search?q=${encodeURIComponent(suggestionText)}`;
        }
      });
    });
  }
  

  
  // ===========================================
  // LEFT COLUMN SUGGESTIONS UPDATE
  // ===========================================
  async updateLeftColumnWithSuggestions(doc, searchTerm) {
    const leftColumn = document.querySelector('.search-results-redesign__suggestions');
    if (!leftColumn) return;
  
    
    const suggestionsList = doc.querySelector('.search-result-pages__list');
    const suggestions = suggestionsList ? suggestionsList.querySelectorAll('.search-result-pages__item') : [];
    
    const collectionsSection = doc.querySelector('.search-result-pages');
    const collections = collectionsSection ? collectionsSection.querySelectorAll('a[href*="/collections/"]') : [];
    
    // Get articles and pages for suggestions
    const allContentItems = doc.querySelectorAll('.search-result-pages__item');
    const articles = [];
    const pages = [];
    
    allContentItems.forEach(item => {
      const link = item.querySelector('a');
      if (link) {
        const url = link.getAttribute('href');
        const title = link.textContent.trim();
        
        if (url.includes('/blogs/') || url.includes('/articles/')) {
          articles.push({ title, url });
        } else if (url.includes('/pages/')) {
          pages.push({ title, url });
        }
      }
    });
    
    const dynamicSuggestions = await this.generateDynamicSuggestions(searchTerm);
    
    const recommendedSearches = [];
    const collectionSuggestions = [];
    const articleSuggestions = [];
    const pageSuggestions = [];
    
    // Validate suggested searches to ensure they return results in current country
    if (this.ENABLE_SUGGESTION_VALIDATION) {
      const validatedSuggestions = [];
      
      for (const suggestion of suggestions) {
        const link = suggestion.querySelector('a');
        if (link) {
          const suggestionText = link.textContent.trim();
          
          const isValid = await this.validateSuggestedSearch(suggestionText);
          if (isValid) {
            validatedSuggestions.push({
              text: suggestionText,
              url: link.href
            });
          }
        }
      }
      
      recommendedSearches.push(...validatedSuggestions);
    } else {
      suggestions.forEach(suggestion => {
        const link = suggestion.querySelector('a');
        if (link) {
          const suggestionText = link.textContent.trim();
          
          recommendedSearches.push({
            text: suggestionText,
            url: link.href
          });
        }
      });
    }
    
    // Curated synonym matches take precedence — pushed before native + dynamic collections.
    const synonymMatches = this.findSynonymMatches(searchTerm);
    const synonymHandles = new Set();
    synonymMatches.forEach(entry => {
      if (this.ENABLE_COUNTRY_FILTERING && !this.isCollectionForCurrentCountry(entry.title)) {
        return;
      }
      synonymHandles.add(entry.handle);
      collectionSuggestions.push({
        text: entry.label,
        url: entry.url
      });
    });

    dynamicSuggestions.forEach(suggestion => {
      if (!suggestion.url.includes('/collections/')) {
        recommendedSearches.push(suggestion);
      } else {
        const handleMatch = suggestion.url.match(/\/collections\/([^\/\?]+)/);
        if (handleMatch && synonymHandles.has(handleMatch[1])) return;
        collectionSuggestions.push(suggestion);
      }
    });
    
    // Add articles to suggestions
    articles.forEach(article => {
      articleSuggestions.push({
        text: article.title,
        url: article.url
      });
    });
    
    // Add pages to suggestions
    pages.forEach(page => {
      pageSuggestions.push({
        text: page.title,
        url: page.url
      });
    });
    
    for (const collection of collections) {
      const collectionText = collection.textContent.trim();
      const collectionUrl = collection.href;
      
      if (collectionUrl && collectionUrl.includes('/collections/') && collectionText) {

        // Filter out collections that are not for the current country (if enabled)
        if (this.ENABLE_COUNTRY_FILTERING && !this.isCollectionForCurrentCountry(collectionText)) {
          continue;
        }

        const nativeHandleMatch = collectionUrl.match(/\/collections\/([^\/\?]+)/);
        if (nativeHandleMatch && synonymHandles.has(nativeHandleMatch[1])) {
          continue;
        }

        if (this.ENABLE_COLLECTION_VALIDATION) {
          const urlMatch = collectionUrl.match(/\/collections\/([^\/\?]+)/);
          if (urlMatch) {
            const collectionHandle = urlMatch[1];
            const isValid = await this.validateCollection(collectionHandle);
            
            if (isValid) {
              collectionSuggestions.push({
                text: collectionText,
                url: collectionUrl
              });
            }
          }
        } else {
          collectionSuggestions.push({
            text: collectionText,
            url: collectionUrl
          });
        }
      }
    }
      
    const title = leftColumn.querySelector('.search-results-redesign__title');
    const suggestionsListElement = leftColumn.querySelector('.search-results-redesign__suggestions-list');
    
    if (title) {
      title.style.display = 'none';
    }
    
    if (suggestionsListElement) {
      let htmlContent = '';
      
      if (recommendedSearches.length > 0) {
        htmlContent += `
          <div class="search-suggestions-section">
            <h3 class="search-results-redesign__title">Popular Searches</h3>
            <ul class="search-suggestions-section__list">
              ${recommendedSearches.slice(0, 4).map(suggestion => `
                <li class="search-results-redesign__suggestion-item">
                  <a href="${suggestion.url}" class="search-results-redesign__suggestion-link" data-suggestion-text="${suggestion.text}">${suggestion.text}</a>
                </li>
              `).join('')}
            </ul>
          </div>
        `;
      }
      
      if (collectionSuggestions.length > 0) {
        htmlContent += `
          <div class="search-suggestions-section">
            <h3 class="search-results-redesign__title">Collections</h3>
            <ul class="search-suggestions-section__list">
              ${collectionSuggestions.slice(0, 4).map(suggestion => `
                <li class="search-results-redesign__suggestion-item">
                  <a href="${suggestion.url}" class="search-results-redesign__suggestion-link" data-suggestion-text="${suggestion.text}">${suggestion.text}</a>
                </li>
              `).join('')}
            </ul>
          </div>
        `;
      }
      
      if (articleSuggestions.length > 0) {
        htmlContent += `
          <div class="search-suggestions-section">
            <h3 class="search-results-redesign__title">Articles</h3>
            <ul class="search-suggestions-section__list">
              ${articleSuggestions.slice(0, 3).map(suggestion => `
                <li class="search-results-redesign__suggestion-item">
                  <a href="${suggestion.url}" class="search-results-redesign__suggestion-link" data-suggestion-text="${suggestion.text}">${suggestion.text}</a>
                </li>
              `).join('')}
            </ul>
          </div>
        `;
      }
      
      if (pageSuggestions.length > 0) {
        htmlContent += `
          <div class="search-suggestions-section">
            <h3 class="search-results-redesign__title">Pages</h3>
            <ul class="search-suggestions-section__list">
              ${pageSuggestions.slice(0, 3).map(suggestion => `
                <li class="search-results-redesign__suggestion-item">
                  <a href="${suggestion.url}" class="search-results-redesign__suggestion-link" data-suggestion-text="${suggestion.text}">${suggestion.text}</a>
                </li>
              `).join('')}
            </ul>
          </div>
        `;
      }
      
      if (htmlContent === '') {
        htmlContent = `
          <div class="search-suggestions-section">
            <ul class="search-suggestions-section__list">
              <li class="search-results-redesign__suggestion-item">
                <a href="/search?q=${encodeURIComponent(searchTerm)}" class="search-results-redesign__suggestion-link" data-suggestion-text="${searchTerm}">Search for "${searchTerm}"</a>
              </li>
            </ul>
          </div>
        `;
      }
      
      suggestionsListElement.innerHTML = htmlContent;
      
      this.addSuggestionClickHandlers(suggestionsListElement);
    }
  }
  
  // ===========================================
  // COLLECTION VALIDATION HELPER
  // ===========================================
  async validateCollection(collectionHandle) {
    if (this.collectionValidationCache.has(collectionHandle)) {
      return this.collectionValidationCache.get(collectionHandle);
    }

    try {
      const collectionProductsUrl = `/collections/${collectionHandle}/products.json?limit=1`;
      const response = await fetch(collectionProductsUrl);
      
      if (response.ok) {
        const data = await response.json();
        const isValid = data.products && data.products.length > 0;
        
        
        this.collectionValidationCache.set(collectionHandle, isValid);
        
        return isValid;
      } 
    } catch (error) {
    }
    this.collectionValidationCache.set(collectionHandle, true);
    return true;
  }
  
  async fetchStoreData() {
    if (this.storeDataCache.lastUpdated && 
        (Date.now() - this.storeDataCache.lastUpdated) < this.storeDataCache.cacheExpiry) {
      return this.storeDataCache;
    }

    try {
      const collectionsUrl = `/collections.json`;
      const collectionsResponse = await fetch(collectionsUrl);
      const collectionsData = await collectionsResponse.json();
      
      const allCollections = collectionsData.collections || [];
      const validCollections = [];
      
      if (this.ENABLE_COLLECTION_VALIDATION) {
        for (const collection of allCollections) {
          try {
            const isValid = await this.validateCollection(collection.handle);
            if (isValid) {
              validCollections.push(collection);
            }
          } catch (error) {
            console.warn(`Error validating collection "${collection.title}":`, error);
            validCollections.push(collection);
          }
        }
      } else {
        validCollections.push(...allCollections);
      }
      
      const productsUrl = `/products.json?limit=50`;
      const productsResponse = await fetch(productsUrl);
      const productsData = await productsResponse.json();
      
      const productTypes = new Set();
      const tags = new Set();
      
      productsData.products.forEach(product => {
        if (product.product_type) {
          productTypes.add(product.product_type);
        }
        if (product.tags) {
          product.tags.forEach(tag => tags.add(tag));
        }
      });
      
      this.storeDataCache = {
        collections: validCollections,
        productTypes: Array.from(productTypes),
        tags: Array.from(tags),
        lastUpdated: Date.now(),
        cacheExpiry: this.storeDataCache.cacheExpiry
      };
    
      
      return this.storeDataCache;
    } catch (error) {
      return this.storeDataCache;
    }
  }
  
  // ===========================================
  // PRODUCT VALIDATION FOR SUGGESTIONS
  // ===========================================
  async validateProductSuggestion(suggestionText) {
    try {
      const searchUrl = `${window.routes.search_url}?q=${encodeURIComponent(suggestionText)}&type=product&limit=1`;
      const response = await fetch(searchUrl);
      
      if (response.ok) {
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const productList = doc.querySelector('#predictive-search-results-list');
        
        return productList && productList.children.length > 0;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  // ===========================================
  // SUGGESTED SEARCH VALIDATION
  // ===========================================
  async validateSuggestedSearch(suggestionText) {
    try {
      // Use the predictive search API to check if this suggestion would return results
      const predictiveSearchUrl = `${window.routes.predictive_search_url}?q=${encodeURIComponent(suggestionText)}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent("resources[limit]")}=1`;
      const response = await fetch(predictiveSearchUrl);
      
      if (response.ok) {
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const productList = doc.querySelector('#predictive-search-results-list');
        
        return productList && productList.children.length > 0;
      }
      
      return false;
    } catch (error) {
      return false;
    }
  }

  // ===========================================
  // DYNAMIC SUGGESTIONS GENERATION
  // ===========================================
  async generateDynamicSuggestions(searchTerm) {
    const suggestions = [];
    const term = searchTerm.toLowerCase();
    
    try {
      const storeData = await this.fetchStoreData();
      
      // Collection suggestions come from predictive search (market-filtered server-side).
      // collections.json is global and ignores custom.market_for_hreflang.
      
      // Only suggest product types that actually exist
      if (storeData.productTypes && storeData.productTypes.length > 0) {
        storeData.productTypes.forEach(productType => {
          const typeLower = productType.toLowerCase();
          if (typeLower.includes(term) || term.includes(typeLower.split(' ')[0])) {
            suggestions.push({
              text: productType,
              url: `/search?q=${encodeURIComponent(productType)}&type=product`
            });
          }
        });
      }
    } catch (error) {
      console.error('Error generating dynamic suggestions:', error);
    }

    
    const uniqueSuggestions = suggestions.filter((suggestion, index, self) => 
      index === self.findIndex(s => s.text === suggestion.text)
    );
    
    return uniqueSuggestions.slice(0, 8);
  }
  
  // ===========================================
  // ORIGINAL CONTENT RESTORATION
  // ===========================================
  restoreOriginalLeftColumn() {
    const leftColumn = document.querySelector('.search-results-redesign__suggestions');
    if (leftColumn && this.originalLeftColumnContent) {
      leftColumn.innerHTML = this.originalLeftColumnContent;
      
      const title = leftColumn.querySelector('.search-results-redesign__title');
      if (title) {
        title.style.display = '';
      }
    }
  }

  // ===========================================
  // SEARCH CLEARING
  // ===========================================
  clearSearch() {
    // Clear any pending search timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    
    // Abort any ongoing search
    if (this.currentSearchAbortController) {
      this.currentSearchAbortController.abort();
      this.currentSearchAbortController = null;
    }
    
    // Reset search term
    this.currentSearchTerm = '';
    
    // Restore original content
    if (this.middleColumn && this.originalMiddleColumnContent) {
      this.middleColumn.innerHTML = this.originalMiddleColumnContent;
    }
    this.restoreOriginalLeftColumn();
    
    const leftColumn = document.querySelector('.search-results-redesign__suggestions');
    if (leftColumn) {
      const title = leftColumn.querySelector('.search-results-redesign__title');
      if (title) {
        title.style.display = '';
      }
    }
  }

  // ===========================================
  // PRODUCT SORTING BY PRIORITY
  // ===========================================
  sortProductsBySaleStatus(productList) {
    if (!productList || !productList.children.length) {
      return productList;
    }
    const products = Array.from(productList.children);
    
    products.sort((a, b) => {
      if (this.productPriority === 'sale') {
        const aIsOnSale = this.isProductOnSale(a);
        const bIsOnSale = this.isProductOnSale(b);
        
        if (aIsOnSale && !bIsOnSale) return -1;
        if (!aIsOnSale && bIsOnSale) return 1;
      } else if (this.productPriority === 'full_price') {
        const aIsOnSale = this.isProductOnSale(a);
        const bIsOnSale = this.isProductOnSale(b);
        
        if (!aIsOnSale && bIsOnSale) return -1;
        if (aIsOnSale && !bIsOnSale) return 1;
      } else if (this.productPriority === 'outlet') {
        const aIsOutlet = this.isProductOutlet(a);
        const bIsOutlet = this.isProductOutlet(b);
        
        if (aIsOutlet && !bIsOutlet) return -1;
        if (!aIsOutlet && bIsOutlet) return 1;
      }
      
      return 0; 
    });
    
    // Create a new product list with sorted items
    const sortedProductList = productList.cloneNode(false);
    products.forEach(product => {
      sortedProductList.appendChild(product);
    });
    
    return sortedProductList;
  }
  
  isProductOutlet(productElement) {
    // Check for custom.store_type metafield
    const storeType = productElement.getAttribute('data-store-type');
    if (storeType && storeType.toLowerCase() === 'outlet') {
      return true;
    }
    
    // Check for outlet badge or indicator
    const outletBadge = productElement.querySelector('[data-badge="outlet"], .badge--outlet, .product-badge--outlet, [data-custom-badge*="outlet"]');
    if (outletBadge) {
      return true;
    }
    
    const productTitle = productElement.querySelector('.card__title')?.textContent?.toLowerCase() || '';
    if (/\boutlet\b/.test(productTitle)) {
      return true;
    }
    
    return false;
  }

  isProductOnSale(productElement) {
    // Check for various sale indicators in the product element
    const productTitle = productElement.querySelector('.card__title')?.textContent?.trim() || 'Unknown';
    
    // Check for price--on-sale class on the main price element (most reliable indicator)
    const priceElement = productElement.querySelector('.price');
    if (priceElement && priceElement.classList.contains('price--on-sale')) {
      return true;
    }
    
    // Check for sale-specific price sections - must be visible AND have different prices
    const salePriceSection = productElement.querySelector('.price__sale');
    if (salePriceSection && salePriceSection.classList.contains('visible')) {
      // Also check if the sale price is actually different from regular price
      const regularPrice = productElement.querySelector('.price__regular .price-item--regular')?.textContent?.trim();
      const salePrice = productElement.querySelector('.price__sale .price-item--sale')?.textContent?.trim();
    
      
      if (regularPrice && salePrice && regularPrice !== salePrice) {
        return true;
      }
    }
    
    const comparePriceElement = productElement.querySelector('.wt-product__price__compare');
    if (comparePriceElement) {
      const hasContent = comparePriceElement.textContent.trim();
      const isHidden = comparePriceElement.classList.contains('hidden');
      const isDisplayNone = comparePriceElement.style.display === 'none';
      
      const regularPrice = productElement.querySelector('.price__regular .price-item--regular')?.textContent?.trim();
      const comparePrice = comparePriceElement.textContent.trim();

      
      if (hasContent && !isHidden && !isDisplayNone && regularPrice && comparePrice !== regularPrice) {
        return true;
      }
    }
    
    const oldPriceElement = productElement.querySelector('.card__price__old');
    if (oldPriceElement && oldPriceElement.textContent.trim()) {
      return true;
    }
    
    const saleBadgeElement = productElement.querySelector('.badge--sale, .product-badge--sale, .sale-badge, .volume-pricing--sale-badge, [data-custom-badge="default-sale"]');
    if (saleBadgeElement) {
      return true;
    }
    
    const saleElements = productElement.querySelectorAll('.price--on-sale, .badge--sale, .product-badge--sale, .sale-badge, .volume-pricing--sale-badge');
    if (saleElements.length > 0) {
      return true;
    }
    
    const saleAttributeElements = productElement.querySelectorAll('[data-sale="true"], [data-on-sale]');
    if (saleAttributeElements.length > 0) {
      return true;
    }
    
    return false;
  }

  // ===========================================
  // SEARCH RESULT RENDERING
  // ===========================================
  extractPagesFromDoc(doc) {
    const pages = [];
    const allContentItems = doc.querySelectorAll('.search-result-pages__item');

    allContentItems.forEach(item => {
      const link = item.querySelector('a');
      if (link) {
        const url = link.getAttribute('href');
        const title = link.textContent.trim();
        const pageImage = item.getAttribute('data-page-image');

        if (url && url.includes('/pages/')) {
          pages.push({ title, url, image: pageImage || null });
        }
      }
    });

    doc.querySelectorAll('a[href*="/pages/"]').forEach(link => {
      const url = link.getAttribute('href');
      const title = link.textContent.trim();

      if (url && url.includes('/pages/') && !pages.some(page => page.url === url)) {
        pages.push({ title, url });
      }
    });

    return pages;
  }

  buildSearchResultsHTML(productList, pages, searchTerm) {
    const hasProducts = productList && productList.children.length > 0;
    const hasPages = pages && pages.length > 0;

    if (!hasProducts && !hasPages) {
      return '';
    }

    let gridItemsHTML = '';

    if (hasProducts) {
      const sortedProductList = this.sortProductsBySaleStatus(productList);
      gridItemsHTML += sortedProductList.innerHTML;
    }

    if (hasPages) {
      gridItemsHTML += pages.slice(0, 3).map((page) => {
        const escapedTitle = this.escapeHtml(page.title);
        const escapedUrl = this.escapeHtml(this.sanitizeUrl(page.url));
        const sanitizedImageSrc = this.sanitizeUrl(page.image);
        const escapedImageSrc = sanitizedImageSrc ? this.escapeHtml(sanitizedImageSrc) : '';
        const imageSrc = escapedImageSrc || 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'500\' height=\'625\'%3E%3C/svg%3E';

        return `
          <li class="search-result-list__item search-result-list__item--page" role="option">
            <div class="card__container">
              <div class="card__picture-container">
                <a href="${escapedUrl}" class="card" tabindex="0" aria-label="${escapedTitle}">
                  <picture class="card__picture">
                    <img
                      src="${imageSrc}"
                      alt="${escapedTitle}"
                      loading="lazy"
                      class="card__img"
                      width="500"
                      height="625"
                    />
                  </picture>
                </a>
              </div>
              <div class="relative card__information">
                <a href="${escapedUrl}" class="card" tabindex="-1">
                  <div class="card__badge">Page</div>
                  <h3 class="card__title">${escapedTitle}</h3>
                </a>
              </div>
            </div>
          </li>
        `;
      }).join('');
    }

    const sectionTitle = hasProducts && hasPages
      ? this.t('search.titles.products_and_pages')
      : hasProducts
      ? this.t('search.titles.products')
      : this.t('search.titles.pages');
    const localePrefix = this.locale || '';
    const searchRoot = (window.routes && window.routes.search_url) || `${localePrefix}/search`;
    const rawViewAllUrl = hasProducts && hasPages
      ? `${searchRoot}?q=${encodeURIComponent(searchTerm)}`
      : hasProducts
      ? `${searchRoot}?q=${encodeURIComponent(searchTerm)}&type=product`
      : `${searchRoot}?q=${encodeURIComponent(searchTerm)}&type=page`;
    const viewAllUrl = this.escapeHtml(rawViewAllUrl);
    const escapedSectionTitle = this.escapeHtml(sectionTitle);
    const viewAllLabel = this.escapeHtml(this.t('search.view_all'));

    return `
      <div class="search-results-redesign__section">
        <div class="search-results-redesign__title-header">
          <h3 class="search-results-redesign__title">${escapedSectionTitle}</h3>
          <a href="${viewAllUrl}" class="search-results-redesign__view-all">${viewAllLabel}</a>
        </div>
        <div class="search-results-redesign__products-grid">
          <ul class="search-result-list" role="listbox">
            ${gridItemsHTML}
          </ul>
        </div>
      </div>
    `;
  }

  // Full storefront search fallback — predictive search is stricter on multi-word queries
  // (e.g. "Mens Tshirt") and often returns nothing while /search finds products.
  fetchStorefrontSearchFallback(searchTerm, signal) {
    const searchRoot = (window.routes && window.routes.search_url) || `${this.locale || ''}/search`;
    const fallbackUrl = `${searchRoot}?q=${encodeURIComponent(searchTerm)}&type=product&section_id=search-drawer-fallback`;

    return fetch(fallbackUrl, { signal })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.text();
      })
      .then(text => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        return doc.querySelector('#predictive-search-results-list');
      });
  }

  // ===========================================
  // PREDICTIVE SEARCH EXECUTION
  // ===========================================
  performPredictiveSearch(searchTerm) {
    if (!this.middleColumn) return;

    searchTerm = this.normalizeSearchTerm(searchTerm);
    if (!searchTerm) {
      this.clearSearch();
      return;
    }
    
    // Clear any existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    
    // Abort any ongoing search
    if (this.currentSearchAbortController) {
      this.currentSearchAbortController.abort();
    }
    
    this.currentSearchAbortController = new AbortController();
    this.currentSearchTerm = searchTerm;
    
    this.fetchLoadingState(this.middleColumn);

    // Use Shopify default searchable fields for best predictive matching.
    // Custom fields (tag, barcode) can over-constrain multi-word queries.
    const predictiveSearchRoot = (window.routes && window.routes.predictive_search_url)
      || `${this.locale || ''}/search/suggest`;
    const predictiveSearchUrl = `${predictiveSearchRoot}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,page,collection,query&${encodeURIComponent("resources[limit_scope]")}=each&${encodeURIComponent("resources[limit]")}=10&${encodeURIComponent("resources[options][unavailable_products]")}=last&section_id=predictive-search`;
    const searchAbortController = this.currentSearchAbortController;
    
    const timeoutId = setTimeout(() => {
      if (this.currentSearchAbortController) {
        this.currentSearchAbortController.abort();
      }
    }, 10000);
    
    fetch(predictiveSearchUrl, { signal: searchAbortController.signal })
      .then(response => {
        clearTimeout(timeoutId);
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.text();
      })
      .then(async text => {
        clearTimeout(timeoutId);
        
        if (this.currentSearchTerm !== searchTerm) {
          return;
        }
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        let productList = doc.querySelector('#predictive-search-results-list');
        const pages = this.extractPagesFromDoc(doc);

        // Predictive search often returns 0 for multi-word queries that full search finds.
        // Fall back to storefront search so the drawer matches the results page.
        if ((!productList || productList.children.length === 0) && pages.length === 0) {
          try {
            const fallbackList = await this.fetchStorefrontSearchFallback(
              searchTerm,
              searchAbortController ? searchAbortController.signal : undefined
            );
            if (fallbackList && fallbackList.children.length > 0) {
              productList = fallbackList;
            }
          } catch (fallbackError) {
            if (fallbackError.name === 'AbortError') {
              return;
            }
            console.error('Storefront search fallback error:', fallbackError);
          }
        }

        if (this.currentSearchTerm !== searchTerm) {
          return;
        }

        const searchResultsHTML = this.buildSearchResultsHTML(productList, pages, searchTerm);
        
        if (searchResultsHTML) {
          this.middleColumn.innerHTML = searchResultsHTML;
        } else {
          this.fetchNoResultsState(this.middleColumn);
        }
        
        this.updateLeftColumnWithSuggestions(doc, searchTerm).catch(error => {
          console.error('Error updating left column suggestions:', error);
        });
      })
      .catch(error => {
        clearTimeout(timeoutId);
        
        if (this.currentSearchTerm === searchTerm) {
          if (error.name === 'AbortError') {
            return;
          }
          
          console.error('Search error:', error);
          
          if (this.middleColumn && this.originalMiddleColumnContent) {
            this.middleColumn.innerHTML = this.originalMiddleColumnContent;
          }
        }
      });
  }
}

if (!window.__pageHeaderSearch) {
  window.__pageHeaderSearch = new PageHeaderSearch();
}